<template>
	<v-dialog v-model="input" max-width="500">
		<v-card class="rounded-xl" elevation="0">
			<v-card-title class="d-flex justify-space-between">
				<div v-if="!addingCredit">Payment</div>
				<div v-else>Add Credit</div>
				<div>
					<v-btn
						rounded
						depressed
						color="primary"
						@click="addPayment"
						:loading="isLoading"
						:disabled="!formValid">
						<i class="fas fa-paper-plane mr-1"></i>
						Submit
					</v-btn>
				</div>
			</v-card-title>
			<v-card-text>
				<v-autocomplete
					class="mb-1"
					rounded
					dense
					outlined
					hide-details
					label="Account"
					:items="customers"
					item-value="id"
					item-text="name"
					:disabled="isLocked"
					v-model="payment.accountId"
					@change="getCustomer"></v-autocomplete>
				<v-autocomplete
					v-if="!addingCredit"
					class="mb-1"
					rounded
					dense
					outlined
					hide-details
					label="Id"
					:items="items"
					item-value="id"
					:item-text="getItemText"
					:disabled="isLocked"
					v-model="payment.invoiceId"
					@change="setAccount"></v-autocomplete>
				<v-autocomplete
					class="mb-1"
					rounded
					dense
					outlined
					hide-details
					label="Currency"
					:items="currencyTypes"
					item-value="id"
					item-text="displayName"
					:disabled="isLocked"
					v-model="payment.currencyId"></v-autocomplete>
				<v-autocomplete
					class="mb-1"
					rounded
					dense
					outlined
					hide-details
					label="Payment Type"
					:items="paymentTypes"
					item-value="id"
					item-text="displayName"
					v-model="payment.typeId"></v-autocomplete>
				<div class="mb-1">
					<date-picker
						label="Payment Date"
						v-model="payment.paymentDate"></date-picker>
				</div>
				<v-autocomplete
					v-if="!addingCredit"
					class="mb-1"
					rounded
					dense
					outlined
					hide-details
					label="Use Credit"
					:items="yesNo"
					item-value="value"
					item-text="text"
					v-model="useCredit"></v-autocomplete>
				<v-textarea
					class="mb-1"
					rounded
					outlined
					hide-details
					label="Description"
					v-model="payment.description"></v-textarea>
				<v-container class="pa-0 d-flex" style="gap: 5px">
					<v-text-field
						dense
						outlined
						rounded
						hide-details
						label="Amount"
						v-model.number="amountReceived"
						@change="handleAmountReceived"></v-text-field>

					<v-btn
						v-if="!addingCredit"
						depressed
						rounded
						color="success"
						@click="setAmount">
						Amount Due
					</v-btn>
				</v-container>
			</v-card-text>
			<v-card-text v-if="!addingCredit">
				<v-container
					v-if="useCredit"
					class="d-flex justify-space-between pa-0">
					<div>Dollar Credit:</div>
					<div class="green--text">
						<span class="mr-1">
							{{ getCurrencySymbol(Dollar) }}
						</span>
						<span>
							{{ convertToCleanNumber(customer.dollarCredit) }}
						</span>
					</div>
				</v-container>
				<v-container
					v-if="useCredit"
					class="d-flex justify-space-between pa-0">
					<div>Dong Credit:</div>
					<div class="green--text">
						<span class="mr-1">{{ getCurrencySymbol(Dong) }}</span>
						<span>
							{{
								convertToCleanNumber(customer.dongCredit, false)
							}}
						</span>
					</div>
				</v-container>
				<v-container class="d-flex justify-space-between pa-0">
					<div>Amount Due:</div>
					<div class="red--text">
						<span class="mr-1">
							{{ getCurrencySymbol(payment.currencyId) }}
						</span>
						<span>
							{{
								convertToCleanNumber(
									selectedInvoice.totalAmount,
									getCurrencySymbol(payment.currencyId) == "$"
								)
							}}
						</span>
					</div>
				</v-container>
				<v-container class="d-flex justify-space-between pa-0">
					<div>Amount Left to Pay:</div>
					<div class="red--text">
						<span class="mr-1">
							{{ getCurrencySymbol(payment.currencyId) }}
						</span>
						<span>
							{{
								convertToCleanNumber(
									selectedInvoice.totalAmount - amountPaid,
									getCurrencySymbol(payment.currencyId) == "$"
								)
							}}
						</span>
					</div>
				</v-container>

				<v-container class="d-flex justify-space-between pa-0">
					<div>Amount to be Credited:</div>
					<div class="warning--text">
						<span class="mr-1">
							{{ getCurrencySymbol(payment.currencyId) }}
						</span>
						<span>
							{{
								convertToCleanNumber(
									toBeCredit,
									getCurrencySymbol(payment.currencyId) == "$"
								)
							}}
						</span>
					</div>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service.js";
import DatePicker from "@/components/DatePicker.vue";
export default {
	name: "PaymentDialog",
	mixins: [generalMixin],
	components: { "date-picker": DatePicker },
	props: {
		addingCredit: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
		pCustomer: {
			type: Object,
			default: () => {
				return {};
			},
		},
		isLocked: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
		invoice: {
			type: Object,
			default: () => {
				return {};
			},
		},
		value: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
	},
	mounted: function () {
		if (this.isLocked && this.invoice.id) {
			this.payment = {
				invoiceId: this.invoice.id,
				accountId: this.invoice.customerId,
				currencyId: this.invoice.currencyId,
			};
			this.getCustomer();
			if (this.items.length == 0) {
				this.$store.dispatch("getInvoices");
			}
		} else if (this.addingCredit) {
			this.$set(this.payment, "accountId", this.pCustomer.id);
		}
	},
	computed: {
		formValid() {
			if (
				!this.addingCredit &&
				this.payment.typeId &&
				this.payment.accountId &&
				this.payment.invoiceId &&
				this.payment.paymentDate &&
				this.amountReceived
			) {
				return true;
			} else if (
				this.addingCredit &&
				this.payment.accountId &&
				this.payment.currencyId &&
				this.payment.typeId &&
				this.payment.paymentDate &&
				this.amountReceived > 0
			)
				return true;
			return false;
		},
		customers() {
			return this.$store.getters["customers"];
		},
		input: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		items() {
			return this.$store.getters["invoices"];
		},
		currencyTypes() {
			if (this.$store.getters["dropdownToOptions"]["currency"])
				return this.$store.getters["dropdownToOptions"]["currency"]
					.options;
			return [];
		},
		paymentTypes() {
			if (this.$store.getters["dropdownToOptions"]["paymentType"]) {
				return this.$store.getters["dropdownToOptions"]["paymentType"]
					.options;
			}
			return [];
		},
		selectedInvoice() {
			if (this.payment.invoiceId) {
				const invoice = this.items.find(
					(e) => e.id == this.payment.invoiceId
				);
				if (invoice) {
					return invoice;
				} else {
					return {
						totalAmount: 0,
					};
				}
			}
			return { totalAmount: 0 };
		},
		toBeCredit() {
			const credit =
				this.amountReceived -
				this.amountPaid -
				this.selectedInvoice.totalAmount;
			if (credit < 0) return 0;
			return credit;
		},
		amountPaid() {
			if (this.isLocked && this.invoice.id) {
				let sum = 0;
				let payments = this.invoice.payments;
				for (let i = 0; i < payments.length; i++) {
					sum += payments[i].amount + payments[i].credit;
				}
				return sum;
			} else if (this.selectedInvoice && this.selectedInvoice.payments) {
				let sum = 0;
				let payments = this.selectedInvoice.payments;
				for (let i = 0; i < payments.length; i++) {
					sum += payments[i].amount;
				}
				return sum;
			}
			return 0;
		},
	},
	data() {
		return {
			payment: {},
			isLoading: false,
			customer: {},
			useCredit: false,
			amountReceived: 0,
		};
	},
	methods: {
		addPayment() {
			this.isLoading = true;
			if (this.useCredit) {
				this.payment.credit = this.amountReceived;
			} else {
				this.payment.amount = this.amountReceived;
			}
			backendService
				.addPayment(this.payment)
				.then((response) => {
					this.timer(1000).then(() => {
						this.input = false;
						this.isLoading = false;
						this.$emit("handle-event", response.data);
						this.successSnackbar(
							"Successfully added a new payment"
						);
					});
				})
				.catch(() => {
					this.isLoading = false;
					this.errorSnackbar("Ops! Something is not right");
				});
		},
		getCustomer() {
			backendService
				.getCustomerById(this.payment.accountId)
				.then((response) => {
					this.customer = response.data;
				});
		},
		getItemText(item) {
			if (item) {
				return `${item.id} - ${this.getOptionName(
					item.paymentStatusId
				)}`;
			}
		},
		handleAmountReceived() {
			if (this.useCredit) {
				if (
					this.payment.currencyId == this.Dong &&
					this.amountReceived - this.customer.dongCredit > 0
				) {
					this.amountReceived = this.customer.dongCredit;
				}
				if (
					this.payment.currencyId == this.Dollar &&
					this.amountReceived - this.customer.dollarCredit > 0
				) {
					this.amountReceived = this.customer.dollarCredit;
				}
			}
		},
		setAmount() {
			this.amountReceived =
				this.selectedInvoice.totalAmount - this.amountPaid;
		},
		setAccount() {},
	},
	watch: {},
};
</script>
